import { useBranding } from "../../../context/BrandingContext";

interface IBaseLayoutProps {
  children: React.ReactNode;
  section?: string;
}

export const BaseLayoutNoMenu: React.FC<IBaseLayoutProps> = ({ children }) => {
  const { logoSrc, logoAlt } = useBranding();
  return (
    <div className="w-full h-screen relative bg-white" data-testid="app">
      <div className="w-full h-[60px] flex items-center justify-between px-2 md:px-8 md:border-b-2 border-[#EBEBF8] bg-nav-bg z-10 gap-2">
        <img
          src={logoSrc}
          alt={logoAlt}
          className="max-w-[135px] max-h-[25px]"
        />
      </div>
      <div className="w-full flex">{children}</div>
    </div>
  );
};
